import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslate } from "react-translate";
// reactstrap components
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Button } from "reactstrap";
import history from 'historyRouter';
// core components
const Dashboard = () => {
  const { mobile } = useSelector((state) => state.commonReducer);
  const tIframe = useTranslate("sidebar");
  const tLaboratory = useTranslate('laboratory-studies');
  const tProfile = useTranslate('profile');
  const tInbox = useTranslate('messages');
  const tDashboard = useTranslate('dashboard');
  const laboratoryNotifications = useSelector(
    (state) => state.notificationsReducer["laboratory"]
  );
  const messageNotifications = useSelector(
    (state) => state.notificationsReducer["messages"]
  );

  return (
    <Fragment>
      <div className="content">
        <Card>

          <CardHeader>
            <CardTitle className="d-flex align-content-center">
                <div className="general-card-title-img text-primary mr-2">
                  <i className="icon-d" />
                </div>
                <div className="general-card-title text-primary">
                  {"Home"}
                </div>
            </CardTitle>
          </CardHeader>

          <CardBody>

            
            <div className="d-flex justify-content-center">
              <Row style={{maxWidth: "885px", width: "100%"}} className="justify-content-around">
                <Col xs={6} className="d-flex justify-content-center"></Col>
                <Col xs={6} className="d-flex justify-content-end" style={{marginBottom: "40px"}}>
                  <Button 
                    color="danger" 
                    onClick={() => { 
                      history.push(`/admin/frametest?redirect=${window.btoa("ifr_appointments_review.php?base=NPR-LUHISVVZNYA7Iumq40J3Hv7F4F0qgX-v71A5N0YmY64t9Pq9KpwJWk7hO5gWzpWQ3c-jsx-c4392DTLroMhdnVpaCXOOXQjR/CI-ULKjCa5JQ9aqPrXJP19EBfAsRoDKpXnBh/JPB/VGVP7lflgZKg1SpzRxnZQEWGzW4p6sLssSbYNJHi-ZBmWWWqz0rXWS91rw08bCdX-n/bWxOiTZ8VVKapMHCbMQItcmXhH8//m-6LIpyOH8vh4hN/A47DOoPDe1FAFoF1AdFjvNx4lE/x6atLH4mBXK-UfeH0Eh3PIbOaIXOdR-31OxPZsBVd5Kkmm2turRYRuGjbqSS-/OqzIDbUM7rGm8fjmBY/Pj2JajQday3JTbzUneTY9pIFTXm2G-3Hw1YSrGItTF4OJ1kyglpb5ELwQnV1KEWUlgkUwTPB0jdwxMhHmZhKVEuCeshn0jZh397aA0tZ4vc4fwNH-uJ47Guq5LRoIbjL6bhRjl4RQSnZuMlNFlR/lI7jfB59JVWEy2y7-jVkrzlcb1U9v24WIQSkMpSJ9yveM=")}`)
                    }
                  }>
                    {tDashboard("cancel-device")}
                  </Button>
                </Col>
              </Row>
            </div>

            <div className="d-flex justify-content-center">
              <Row className="justify-content-around" style={{maxWidth: "900px", width: "100%"}}>
                <Col xs={6} className="d-flex justify-content-center">
                  <Card onClick={() => {history.push(`/admin/frametest`)}} className="dashboard-button">
                    <CardHeader>
                      <CardTitle tag="h2" className="d-flex align-items-center justify-content-center">
                        <span className="text-info icon icon-appointments" style={{fontSize: "100px"}}></span>
                      </CardTitle>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                      <div className="dashboard-text">{tIframe("iframe")}</div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xs={6} className="d-flex justify-content-center">
                  <Card onClick={() => {history.push(`/admin/inbox`)}} className="dashboard-button">
                    {messageNotifications.unreaded > 0 ? (
                      <span className={`widget-notification-counter${messageNotifications.unreaded > 99 ? '-plus' : ''}`}>
                        {messageNotifications.unreaded > 99 ? "99" : messageNotifications.unreaded}
                      </span>
                    ) : (<></>)}
                    <CardHeader>
                      <CardTitle tag="h2" className="d-flex align-items-center justify-content-center">
                        <span className="text-info icon icon-inbox-header mr-2" style={{fontSize: "100px"}}></span>
                      </CardTitle>
                    </CardHeader>

                    <CardBody className="d-flex justify-content-center">
                      <div className="dashboard-text">{tInbox('title')}</div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>

            <div className="d-flex justify-content-center">
              <Row className="justify-content-center mt-3" style={{maxWidth: "900px", width: "100%"}}>
                <Col xs={6} className="d-flex justify-content-center">
                  <Card onClick={() => {history.push(`/admin/lab-studies`)}} className="dashboard-button">
                    {laboratoryNotifications.unreaded > 0 ? (
                      <span className={`widget-notification-counter${laboratoryNotifications.unreaded > 99 ? '-plus' : ''}`}>
                        {laboratoryNotifications.unreaded > 99 ? "99" : laboratoryNotifications.unreaded}
                      </span>
                    ) : (<></>)}
                    <CardHeader>
                      <CardTitle tag="h2" className="d-flex align-items-center justify-content-center">
                        <span className="text-info icon icon-microscope" style={{fontSize: "100px"}}></span>
                      </CardTitle>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                      <div className="dashboard-text">{tLaboratory('laboratory-studies')}</div>
                    </CardBody>
                  </Card>
                </Col>

                <Col xs={6} className="d-flex justify-content-center">
                  <Card onClick={() => {history.push(`/admin/profile`)}} className="dashboard-button">
                    <CardHeader>
                      <CardTitle tag="h2" className="d-flex align-items-center justify-content-center">
                        <span className="text-info icon-user-active" style={{fontSize: "100px"}}></span>
                      </CardTitle>
                    </CardHeader>
                    <CardBody className="d-flex justify-content-center">
                      <div className="dashboard-text">{tProfile("title")}</div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>

          </CardBody>
        </Card>
      </div>
    </Fragment>
  );
};

export default Dashboard;
